var exports = {
  "D": "instructionsContainer__FkYSd-",
  "w": "grow__YjzZI2",
};

module.exports = exports;
